/**
 * Created by zad on 17/10/19.
 */
export default function createAction(type, ...names) {
  return (...args) => {
    const action = { type };
    args.forEach((arg, index) => {
      if (arg !== undefined) {
        action[names[index]] = arg;
      }
    });
    return action;
  };
}



// WEBPACK FOOTER //
// ./src/utils/createAction.js